module.exports = __webpack_public_path__ + "static/media/filter-icon-2-pressed.e4a8062a.svg";